import { Alert, Spin } from "antd"
import React, { useState, useEffect } from 'react';
const initState = {
    is_not: null,
    isSuccess: null,
    errorSuccess: null, 
}

const removeToken = ()=> localStorage.removeItem('email_verification')

const EmailVerification = ({ location , history }) => {
    const [state, setState] = useState(initState)
    const getToken =  localStorage.getItem('email_verification')

    useEffect(() => {
        if(!getToken) return history.push('/')

        fetch(`/api/verify-email/${getToken}`)
        .then(response => response.json())
        .then(({ success }) => {
            setTimeout(()=> history.push('/login'), 3000);
            removeToken()
            if(success) return setState({...state, isSuccess: true})
            setState({...state, errorSuccess: true})
        })
        .catch(error => {
            setState({...state, is_not: true})
            setTimeout(()=> history.push('/'), 3000);
        })

    }, [location.pathname])

    return (
        <div className="email-verification">
            {
                state.isSuccess ? 
                <Alert message="Ваш емейл подтвержден" type="success" showIcon/> : 
                
                state.errorSuccess? 
                <Alert message="Ваш емейл уже подтвержден" type="info" showIcon/> : 
                
                state.is_not ? 
                <Alert message="Сервер временно не доступен" type="error"/> : 
                
                <Spin size="large" tip="Loading..." />
            }
        </div>
    )
}
export default EmailVerification;


// WEBPACK FOOTER //
// ./src/components/pages/verification/EmailVerification.js